export const CONSULTAR_CODIGO_GTM = "@recepcion-documental/CONSULTAR_CODIGO_GTM";
export const CODIGO_GTM_CONSULTADO = "@recepcion-documental/CODIGO_GTM_CONSULTADO";
export const ERROR_CONSULTANDO_CODIGO_GTM = "@recepcion-documental/ERROR_CONSULTANDO_CODIGO_GTM";
